/**
 * 料金の頁に置く絵の帯 (字なし、1200x330 の webp)。
 * 絵の正本は notes-sandbox/ops/art のサムネの絵柄の部品。文言と金額には触れない飾りなので
 * 読み上げには出さない。頭の帯だけ先に読み、下の帯は近づいてから読む。
 */
export const PRICING_ART_BANDS = {
  head: "/assets/pricing-art/pricing-head-21e8031e24.webp",
  trial: "/assets/pricing-art/pricing-trial-a9915b37c4.webp",
} as const;
const BANDS = PRICING_ART_BANDS;

export function PricingArtBand({ kind }: { kind: keyof typeof BANDS }) {
  const first = kind === "head";
  return (
    <img
      src={BANDS[kind]}
      alt=""
      aria-hidden="true"
      width={1200}
      height={330}
      loading={first ? "eager" : "lazy"}
      decoding={first ? undefined : "async"}
      {...(first ? { fetchPriority: "high" as const } : {})}
      data-pricing-art={kind}
      className="block w-full h-auto rounded-[2px]"
    />
  );
}
